import styled from 'styled-components/macro';

export const LoaderWrapper = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: inherit;
  border-radius: inherit;
`;

export const LoadingText = styled.p`
  font-size: 12px;
  line-height: 18px;
  font-weight: 500;
  margin: 14px 0 0 0;
`;
